import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Blog } from '../blog';
import { FindBlogByrouterLinkResponse } from './findblogbyrouterlinkresponse';
import { FindBlogByRouterLinkRequest } from './findblogbyrouterlinkrequest';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilemanagerComponent } from '../../../filemanager/filemanagerpopup/filemanagerpopup.component';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UpdateBlogRequest } from './updateblogrequest';
import { UpdateBlogResponse } from './updateblogresponse';
import { ApiRequestService } from '../../../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../../toastmessage/toastmessage.service';
import { TranslationService } from '../../../translation/translation.service';
import { HttpError } from '../../../shared/httperror';
import { UploadFileResponse } from '../../../banners/uploadfileresponse';
import { UploadToAnExistingFolderRequest } from '../../../banners/uploadtoanexistingfolderrequest';
import { UploadToAnExistingFolderResponse } from '../../../banners/uploadtoanexistingfolderresponse';
import { MetaTagInput } from '../../../meta/metataginput';
import { BlogEnum } from '../../blogEnum';


@Component({
    selector: 'app-updateblog',
    templateUrl: './updateblog.component.html',
    styleUrls: ['./updateblog.component.scss']
})
export class UpdateblogComponent implements OnInit {

    blogEnumList = Object.values(BlogEnum);

    get isFormValid(): boolean {
        return !!this.blogForm?.valid && !!this.htmlForm?.valid && !!this.metaForm?.valid && this.metaKeywords.length > 0;
    }

    configuratorBaseUrl = '';

    blog: Blog = {
        title: '',
        type: ''
    };

    findBlogByrouterLinkUrl = '/websiteconfigurator/find-blog-by-routerlink';

    updateBlogUrl = '/admin/update-blog';

    blogForm?: FormGroup;

    htmlForm?: FormGroup;

    isExtraSmall: Observable<BreakpointState>;

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    uploadFileToAnExistingFolderUrl = '/admin/updatefile';

    uploadFileToAnExistingFolderRequest: UploadToAnExistingFolderRequest = {};

    uploadFileToAnExistingFolderResponse: UploadToAnExistingFolderResponse = {};

    maxFileSize = 5000000;

    @ViewChild('fileCoverInput') fileCoverInput!: ElementRef;
    fileCover: File | null = null;

    updateCoverFile = false;

    uploadFileResponse: UploadFileResponse = {};

    downloadUri = '';

    fileBaseUrl = '';

    metaForm?: FormGroup;

    metaKeywords: string[] = [];

    metaTagInput: MetaTagInput = {
        ogTitle: '',
        ogDescription: '',
        keywords: ''
    };

    constructor(
        private _toastMessageService: ToastmessageService,
        private _apiRequestService: ApiRequestService,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
        private _translateService: TranslationService,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        private _fb: FormBuilder,
        private _matDialog: MatDialog,
        private readonly breakpointObserver: BreakpointObserver
    ) {

        this.configuratorBaseUrl = _configuratorBaseUrl;
        this.fileBaseUrl = _fileManagerUrl;
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
        this.createBlogForm(this.blog);
        this.createHtmlForm();
        this.createMetaForm(this.metaTagInput);
    }

    ngOnInit(): void {
        this.getBlogByRouterLink();
    }

    getBlogByRouterLink() {
        const lastSegmentOfUrl = window.location.href.split('/').pop();
        const routerLink = lastSegmentOfUrl as string;

        const findBlogByRouterLinkRequest: FindBlogByRouterLinkRequest = {
            routerLink: routerLink
        }

        this._apiRequestService
            .sendRequest<FindBlogByRouterLinkRequest, FindBlogByrouterLinkResponse>(this.configuratorBaseUrl, true, findBlogByRouterLinkRequest, true, this.findBlogByrouterLinkUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();


                    });
                })
            )
            .subscribe((response: FindBlogByrouterLinkResponse) => {
                this.blog = response.blog as Blog;
                this.createBlogForm(response.blog!);
                if (this.blog.meta != null) {
                    this.createMetaForm(this.blog.meta);

                }
                else {
                    this.createMetaForm(this.metaTagInput);
                }
            });

    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    createBlogForm(blog: Blog) {
        this.blogForm = this._fb.group({
            title: [blog.title, [Validators.required]],
            type: [blog.type, [Validators.required]]
        });
    }

    createMetaForm(metaTagInput: MetaTagInput) {
        this.metaForm = this._fb.group({
            ogTitle: [metaTagInput.ogTitle, Validators.required],
            ogDescription: [metaTagInput.ogDescription, Validators.required]
        });
        //TODO keywords is undefined----
        const rawKeywords = (metaTagInput.keywords || '').trim();
        this.metaKeywords = rawKeywords ? rawKeywords.split(',').map(k => k.trim()) : [];
    }

    collectBlogData() {
        let meta: MetaTagInput = {};
        if (this.blog.meta != null) {
            meta = {
                id: this.blog.meta?.id,
                ogTitle: this.metaForm?.controls['ogTitle'].value as string | undefined,
                ogDescription: this.metaForm?.controls['ogDescription'].value as string | undefined,
                ogImage: this.blog.thumbnailUrl,
                keywords: this.metaKeywords.join(', ')
            }
        }
        else if (this.blog.meta == null) {
            meta = {
                ogTitle: this.metaForm?.controls['ogTitle'].value as string | undefined,
                ogDescription: this.metaForm?.controls['ogDescription'].value as string | undefined,
                ogImage: this.blog.thumbnailUrl,
                keywords: this.metaKeywords.join(', ')
            }
        }
        this.blog.title = this.blogForm?.controls['title'].value as string | undefined;
        this.blog.innerHtml = this.htmlForm?.controls['html'].value as string | undefined;
        this.blog.type = this.blogForm?.controls['type'].value as string | undefined;
        this.blog.meta = meta

    }

    createHtmlForm() {
        this.htmlForm = this._fb.group({
            html: ['', [Validators.required]],

        });
    }

    updateBlog() {
        this.collectBlogData();
        console.log(this.blog)

        const updateBlogRequest: UpdateBlogRequest = {
            blog: this.blog
        }

        this._apiRequestService
            .sendRequest<UpdateBlogRequest, UpdateBlogResponse>(this.configuratorBaseUrl, true, updateBlogRequest, true, this.updateBlogUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();


                    });
                })
            )
            .subscribe((response: UpdateBlogResponse) => {
                this._toastMessageService.displayToastMessage(TOAST_STATE.success, response.responseMessage!, MAT_ICON.success);
                this.dismissError();
                if (this.fileCover?.size! > this.maxFileSize) {
                    this._toastMessageService.displayToastMessage(
                        TOAST_STATE.error,
                        this._translateService.translate('A maximum fájl korlát 5MB. Kérem ennél kisebb méretű fájlt töltsön fel!'),
                        MAT_ICON.error
                    );
                    this.dismissError();
                    return;
                }
                if (this.fileCover !== null && this.fileCover.size < this.maxFileSize) {
                    this.updateFile(this.blog.thumbnailUrl!);
                }
            });
    }

    openFileManagerPopup() {
        const popupDialog = this._matDialog.open(FilemanagerComponent, {
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size: any) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

    updateFile(thumbNailUrl: string) {

        const folderName = thumbNailUrl.split('/').pop() as string;

        this._apiRequestService.updateFile(this.fileCover!, folderName, true, true, this.fileBaseUrl, this.uploadFileToAnExistingFolderUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage), MAT_ICON.error);
                        this.dismissError();
                    });
                })
            )
            .subscribe((response) => {
                this.uploadFileResponse = response as UploadFileResponse;
                this.downloadUri = this.uploadFileResponse.downloadUri as string;
                if (this.uploadFileResponse.downloadUri) {
                    this._toastMessageService.displayToastMessage(
                        TOAST_STATE.success,
                        'Sikeres fájl feltöltés ' + this.uploadFileResponse.fileName!,
                        MAT_ICON.success
                    );
                    this.dismissError();
                    this.updateCoverFile = false;
                }

            });
    }

    onChange(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileCover = target.files![0];
        if (this.fileCover.name.split('.').pop() === 'jpg' || 'JPEG' || 'JPG' || 'png' || 'jpeg') {
            this.updateCoverFile = true;
        }
        else {
            this.updateCoverFile = false;
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'Kérem ".jpg" vagy .png kiterjesztésű fájlt töltsön fel!', MAT_ICON.warning);
            this.dismissError();
        }
        this.updateCoverFile = true;
    }

    clearSelectedCoverFile() {
        this.fileCoverInput.nativeElement.value = null;
        this.updateCoverFile = false;
    }

    chooseType(blogType: string) {
        this.blog.type = blogType;
        console.log(this.blog.type)
    }
}
